var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 127,
    viewBox: "0 0 127 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97 0.000366211H30C13.4315 0.000366211 0 13.4318 0 30.0004V97.0004C0 113.569 13.4315 127 30 127H97C113.569 127 127 113.569 127 97.0004V30.0004C127 13.4318 113.569 0.000366211 97 0.000366211Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M97 0.000366211H30C13.4315 0.000366211 0 13.4318 0 30.0004V97.0004C0 113.569 13.4315 127 30 127H97C113.569 127 127 113.569 127 97.0004V30.0004C127 13.4318 113.569 0.000366211 97 0.000366211Z",
    fill: "url(#paint0_linear_296_4226)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8371 75.6442C94.2411 75.6442 97.0001 72.8412 97.0001 69.3842C97.0001 65.9272 94.2411 63.1252 90.8371 63.1252C87.4331 63.1252 84.6731 65.9272 84.6731 69.3842C84.6731 72.8412 87.4331 75.6442 90.8371 75.6442Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8291 87.3193C91.6531 88.1713 90.3761 88.8933 88.9581 88.9263C85.9041 89.0003 83.7701 85.9863 82.2071 83.3153L63.1471 50.6943C61.9291 48.6063 60.7031 46.5093 59.1851 44.6393C57.3981 42.4353 55.2371 40.5743 52.9941 38.8473C49.6851 36.2923 46.1381 33.9813 42.2361 32.528C38.8761 31.2734 35.2111 30.6762 31.6501 31.1762C29.8223 31.4308 29.7357 32.3521 30.3241 33.9723C30.9571 35.7363 31.9101 37.3563 32.8541 38.9583C40.6261 52.1813 48.3951 65.3983 56.1671 78.6203C59.6591 84.5603 63.4571 90.8013 69.5151 93.9583C73.6681 96.1253 78.6511 96.5883 83.1231 95.2313C87.5951 93.8703 91.5071 90.7043 93.8041 86.5793C93.4851 86.8293 93.1621 87.0793 92.8291 87.3193Z",
    fill: "url(#paint1_linear_296_4226)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_296_4226",
    x1: 63.5,
    y1: 48.2604,
    x2: -27.2343,
    y2: -85.2441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_296_4226",
    x1: 33.6561,
    y1: 8.25971,
    x2: 91.2011,
    y2: 110.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD36A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#D9AF88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A980AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#835BCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#6841E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#5731F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#522CF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#4857D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#3C8CA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#33B57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#2CD364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#28E554"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27EC4F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.af7a92732dd3ef1e261c08125d0f31b3.svg";
export { ForwardRef as ReactComponent };